/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_DescriptionInputs */

const en_job_description = /** @type {(inputs: Job_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job Description`)
};

const de_job_description = /** @type {(inputs: Job_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stellenbeschreibung`)
};

/**
* | output |
* | --- |
* | "Job Description" |
*
* @param {Job_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const job_description = /** @type {((inputs?: Job_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_description(inputs)
	return en_job_description(inputs)
});